NHS.Scripts.Mortgage = function () {
 
};

NHS.Scripts.Mortgage.prototype =
{
    initializeCalculator: function () {

        var self = this;

        jQuery("#Calculate").click(function () {
            jQuery("#CalcUpdateProgress").show();
            var data = {
                CalcLoanAmount: jQuery("#CalcLoanAmount").val(),
                CalcDownPayment: jQuery("#CalcDownPayment").val(),
                CalcLoanTerm: jQuery("#CalcLoanTerm").val(),
                CalcInterestRate: jQuery("#CalcInterestRate").val(),
                CalcPropertyTax: jQuery("#CalcPropertyTax").val(),
                CalcInsurance: jQuery("#CalcInsurance").val()
            }
            jQuery.ajax({
                type: "POST",
                url: "/mortgagecalculator/calculate",
                data: data,
                success: function (msg) {
                    jQuery("#CalcMonthlyPayment").html(msg);
                    jQuery("#CalcUpdateProgress").hide();
                }
            });
        });
    },

    initializeRates: function () {

        var self = this;

        jQuery("#hiddenProductId").val("1");
        jQuery("#hiddenPointId").val("1");

        init(jQuery('#hiddenDownPayment').val(), jQuery('#hiddenDownPayment').attr('id'));

        jQuery("#btnGetQuotes").click(function () {
            jQuery("#CalcUpdateProgress").show();
            jQuery("#nhs_Loading").show();
            var data = {
                CommunityID: jQuery("#hiddenCommunityId").val(),
                ProductID: jQuery("#hiddenProductId").val(),
                PointID: jQuery("#hiddenPointId").val(),
                DownPay: jQuery("#hiddenDownPayment").val(),
                PostalCode: jQuery("#hiddenPostalCode").val()
            }
            jQuery.ajax({
                type: "POST",
                url: "/mortgagerates/getmatches",
                data: data,
                success: function (msg) {
                    jQuery("#pLoanMatches").html(msg);
                }
            });
            jQuery.ajax({
                type: "POST",
                url: "/mortgagerates/getrates",
                data: data,
                success: function (msg) {
                    SetLoanHeader(jQuery('#radValue').text());
                    jQuery("#pnlContent").html(msg);
                    jQuery("#CalcUpdateProgress").hide();
                    jQuery("#nhs_Loading").hide();
                }
            });            

        });
    }
}
